var SmarticoBlockType = /* @__PURE__ */ ((SmarticoBlockType2) => {
  SmarticoBlockType2["Pathname"] = "pathname";
  SmarticoBlockType2["Cashier"] = "cashier";
  SmarticoBlockType2["Game"] = "game";
  return SmarticoBlockType2;
})(SmarticoBlockType || {});
export {
  SmarticoBlockType
};
